class StickyHeader extends HTMLElement {
  constructor() {
    super();

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.ticking = false;
  }

  connectedCallback() {

    if (window.stickyHeaderInitialized) return;
    window.stickyHeaderInitialized = true;

    this.header = document.querySelector('.section-header');
    this.headerWrapper = this.querySelector('.header-wrapper');
    this.announcement = document.querySelector('.announcement-bar-section');
    this.transparentHeader = this.header?.querySelector('.transparent-header');

    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';

    this.predictiveSearch = this.querySelector('predictive-search');

    // Cache heights
    this.headerHeight = this.header ? this.header.offsetHeight : 0;
    this.announcementHeight = this.announcement ? this.announcement.offsetHeight : 0;

    document.documentElement.style.setProperty(
      '--header-height',
      `${this.headerHeight}px`
    );

    this.setHeaderTop();

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    }

    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.addEventListener(
      'preventHeaderReveal',
      this.hideHeaderOnScrollUp
    );

    // PASSIVE EVENTS
    window.addEventListener(
      'scroll',
      this.onScroll.bind(this),
      { passive: true }
    );

    window.addEventListener(
      'resize',
      this.handleResize.bind(this),
      { passive: true }
    );

    this.observeAnnouncement();
  }

  handleResize() {

    clearTimeout(this.resizeTimer);

    this.resizeTimer = setTimeout(() => {

      this.headerHeight = this.header ? this.header.offsetHeight : 0;
      this.announcementHeight = this.announcement
        ? this.announcement.offsetHeight
        : 0;

      document.documentElement.style.setProperty(
        '--header-height',
        `${this.headerHeight}px`
      );

      this.setHeaderTop();

    }, 150);
  }

  setHeaderTop() {

    if (!this.announcement || !this.header) return;

    if (!this.header.classList.contains('scrolled-past-header')) {
      this.header.style.top = `${this.announcementHeight}px`;
    }
  }

  observeAnnouncement() {

    if (!this.announcement) return;

    const observer = new IntersectionObserver(
      (entries) => {

        entries.forEach((entry) => {

          if (entry.isIntersecting) {

            this.header.classList.remove('scrolled-past-header');

            if (this.transparentHeader) {
              this.transparentHeader.classList.add('transparent-header');
            }

            this.setHeaderTop();

          } else {

            this.header.classList.add('scrolled-past-header');

            if (this.transparentHeader) {
              this.transparentHeader.classList.remove('transparent-header');
            }

            this.header.style.top = '0px';
          }
        });

      },
      {
        threshold: 0
      }
    );

    observer.observe(this.announcement);
  }

  onScroll() {

    if (this.ticking) return;

    this.ticking = true;

    requestAnimationFrame(() => {

      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch?.isOpen) {
        this.ticking = false;
        return;
      }

      if (scrollTop > this.currentScrollTop) {

        if (!this.preventHide) {
          this.hide();
        }

      } else {

        if (!this.preventReveal) {

          this.reveal();

        } else {

          clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          this.hide();
        }
      }

      this.currentScrollTop = scrollTop;
      this.ticking = false;

    });
  }

  hide() {

    if (this.headerIsAlwaysSticky) return;

    this.header.classList.add(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky'
    );

    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {

    if (this.headerIsAlwaysSticky) return;

    this.header.classList.add(
      'shopify-section-header-sticky',
      'animate'
    );

    this.header.classList.remove(
      'shopify-section-header-hidden'
    );
  }

  closeMenuDisclosure() {

    this.disclosures =
      this.disclosures ||
      this.header.querySelectorAll('header-menu');

    this.disclosures.forEach((disclosure) =>
      disclosure.close()
    );
  }

  closeSearchModal() {

    this.searchModal =
      this.searchModal ||
      this.header.querySelector('details-modal');

    if (this.searchModal) {
      this.searchModal.close(false);
    }
  }
}

customElements.define('sticky-header', StickyHeader);